'use strict';

var React = require('react');

var SvgPaperCheckMajor = function SvgPaperCheckMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.778 2.06a1.5 1.5 0 1 1 2.121 2.122l-2.12-2.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.071 2.768 2.121 2.121-5.656 5.657-2.475.354.353-2.475 5.657-5.657Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8a2 2 0 0 1 2-2h4v2h-4v8h16v-8h-1v-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13a1 1 0 0 1 1-1h8v2h-8a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12a1 1 0 0 1 0 2v-2Z"
  }));
};

exports.SvgPaperCheckMajor = SvgPaperCheckMajor;
